import { GridColDef } from "@mui/x-data-grid";

export const ON_CALL_HEADERS: GridColDef[] = [
  {
    headerName: "Id",
    field: "id"
  },
  {
    headerName: "Team",
    field: "team"
  },
  {
    headerName: "Name",
    field: "name"
  },
  {
    headerName: "Phone Number",
    field: "phoneNumber"
  },
  {
    headerName: "Email",
    field: "email"
  }
];

export const DASHBOARD_HEADERS: GridColDef[] = [
  {
    headerName: "Id",
    field: "id"
  },
  {
    headerName: "Reason ID",
    field: "reasonId"
  },
  {
    headerName: "Reason",
    field: "reason"
  },
  {
    headerName: "Created On",
    field: "createdOn"
  }
];
